import React from "react";
import { Link } from "react-router-dom";
import Chart from "react-google-charts";

const TYPE_COLORS = {
  CERAMIC: "#c82534",
  DIESEL: "#2c6fbb",
  "AFTER MKT": "#00965a",
  "DOMESTIC WIRE": "#e8a317",
  "FOREIGN WIRE": "#6b4c9a",
};

export function CatalogAssayWithoutVisual({ summary }) {
  const oems = summary?.withoutAssayOems || [];
  const byType = summary?.withoutAssayByType || [];

  if (!oems.length) {
    return (
      <div className="converter-testing-glance-panel converter-testing-catalog-assay-without-panel">
        <div className="converter-testing-glance-title">Without catalog assay</div>
        <div className="c-gray fs-14">All converters have catalog assay values on file.</div>
      </div>
    );
  }

  const chartData = [
    ["Type", "Without assay"],
    ...byType.map((row) => [row.type, row.count ?? 0]),
  ];

  return (
    <div className="converter-testing-glance-panel converter-testing-catalog-assay-without-panel">
      <div className="converter-testing-glance-header">
        <div>
          <div className="converter-testing-glance-title">Without catalog assay — OEMs at a glance</div>
          <div className="converter-testing-glance-subtitle c-gray fs-13">
            {oems.length.toLocaleString()} converters missing catalog assay values
          </div>
        </div>
        <div className="converter-testing-glance-badge converter-testing-glance-badge-red">
          {oems.length.toLocaleString()}
        </div>
      </div>

      <div className="converter-testing-no-tests-charts">
        {byType.length > 0 && (
          <div className="converter-testing-chart-card">
            <div className="converter-testing-chart-title">Without catalog assay by type</div>
            <Chart
              chartType="BarChart"
              width="100%"
              height="220px"
              data={chartData}
              options={{
                legend: { position: "none" },
                chartArea: { width: "70%", height: "72%" },
                hAxis: { textStyle: { fontSize: 11 }, minValue: 0 },
                vAxis: { textStyle: { fontSize: 11 } },
                colors: ["#c82534"],
              }}
              loader={<div className="c-gray fs-13">Loading chart...</div>}
            />
          </div>
        )}

        <div className="converter-testing-no-tests-legend">
          {byType.map((row) => (
            <div key={row.type} className="converter-testing-type-legend-item">
              <span
                className="converter-testing-type-dot"
                style={{ background: TYPE_COLORS[row.type] || "#999" }}
              />
              <span className="fs-12 fw-bolder">{row.type}</span>
              <span className="fs-12 c-gray">({row.count})</span>
            </div>
          ))}
        </div>
      </div>

      <div className="converter-testing-oem-chip-grid">
        {oems.map((item) => {
          const typeColor = TYPE_COLORS[item.type] || "#999";
          const hasTests = (item.testCount ?? 0) > 0;
          return (
            <Link
              key={item.productId}
              to={`/converter/${item.productId}`}
              className="converter-testing-oem-chip converter-testing-oem-chip-ranked"
              style={{ borderLeftColor: typeColor }}
              title={[item.type, item.description || null, hasTests ? `${item.testCount} tests` : "No tests"]
                .filter(Boolean)
                .join(" · ")}
            >
              <span className="converter-testing-oem-chip-text">{item.oem || item.productId}</span>
              <span className="converter-testing-oem-chip-meta">
                <span className="converter-testing-oem-chip-type">{item.type}</span>
                <span
                  className={`converter-testing-oem-chip-count ${
                    hasTests ? "converter-testing-oem-chip-count-warn" : ""
                  }`}
                >
                  {hasTests ? `${item.testCount} tests` : "No tests"}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
